export default __webpack_public_path__ + "static/house_1-93d7e0e0508e3e16b7fd2c858b8d0019.png";